module.exports = __webpack_public_path__ + "images/emptyListData.f22df2d9ac9ec25ac9ae66ecab77d20a.png";